<template><div><h1 id="auftragsart" tabindex="-1"><a class="header-anchor" href="#auftragsart"><span>Auftragsart</span></a></h1>
<p>Auftragsart — Definiert Eigenschaften der Auftragsbearbeitung</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auftragsart definiert die wesentlichsten Eigenschaften der Auftragsabwicklung. Darunter sind:</p>
<ul>
<li>
<p>Standard-Porto</p>
</li>
<li>
<p>Auslieferlager</p>
</li>
<li>
<p>Rechnungsformular</p>
</li>
<li>
<p>ESR-Nummer</p>
</li>
<li>
<p>Zahlungsfrist</p>
</li>
<li>
<p>Etc.</p>
</li>
</ul>
<div class="hint-container tip">
<p class="hint-container-title">Anmerkung</p>
<p>Da die Abhängigkeiten innerhalb des System sehr hoch sind, wird empfohlen, das Einrichten neuer Auftragsarten nur in Rücksprache mit Arenae vorzunehmen.</p>
</div>
<p>funtrade kennt verschiedene Abwicklungsarten von Aufträgen, welche als eigene Prozesse eingerichtet werden können und in der Auftragsart definiert werden. Im Folgenden werden anhand von Beispielen die verschiedenen Abwicklungsarten vorgestellt.</p>
<h3 id="auftragsabwicklung-unterstutzte-methoden" tabindex="-1"><a class="header-anchor" href="#auftragsabwicklung-unterstutzte-methoden"><span>Auftragsabwicklung: Unterstützte Methoden</span></a></h3>
<h4 id="dauerauftrag" tabindex="-1"><a class="header-anchor" href="#dauerauftrag"><span>Dauerauftrag</span></a></h4>
<p>Dient der Erfassung von Aufträgen, die einmal oder mehrmals jährlich bis auf Widerruf des Kunden laufen. Bei einer Auftragsart, die mit der Funktionalität &quot;Dauerauftrag&quot; versehen ist, reagiert das System wie folgt:</p>
<p>Bei der erstmaligen Fakturierung wird der Auftrag normal fakturiert, und - abhängig vom Schalter vorausfakturierbar - wird ein WBS mit ESR gedruckt bzw. lediglich ein Lieferschein.</p>
<p>Je nach Einstellung &quot;Anzahl Lieferungen jährlich&quot; in der Auftragsart wird automatisch eine Kopie dieses Original-Auftrags erstellt, der dann zum Zeitpunkt der nächsten Fakturierung ausgeführt wird. Zum Beispiel:</p>
<table>
<thead>
<tr>
<th>Anzahl Lieferungen jährlich</th>
<th>Datum Erstfakturierung</th>
<th>nächste Fakturierung ab:</th>
</tr>
</thead>
<tbody>
<tr>
<td>1</td>
<td>1.1.99</td>
<td>1.1.2000</td>
</tr>
<tr>
<td>2</td>
<td>1.1.99</td>
<td>1.7.99</td>
</tr>
<tr>
<td>3</td>
<td>1.1.99</td>
<td>1.4.99</td>
</tr>
<tr>
<td>4</td>
<td>1.1.99</td>
<td>1.3.99</td>
</tr>
<tr>
<td>12</td>
<td>1.1.99</td>
<td>1.2.99</td>
</tr>
</tbody>
</table>
<p>Die Kopien der Aufträge werden solange fortgesetzt, bis der ursprüngliche Auftrag als erledigt markiert wird. Siehe dazu im Detail <RouteLink to="/manual/trade/dauerauftraege_alt.html">Daueraufträge)</RouteLink>.</p>
<h4 id="sammelauftrag" tabindex="-1"><a class="header-anchor" href="#sammelauftrag"><span>Sammelauftrag</span></a></h4>
<p>Dient der Erfassung von Aufträgen, bei denen die Kunden zwar mehrere (Teil)Lieferungen erhalten sollen, aber nur eine Rechnung erstellt werden soll.</p>
<h4 id="sammelfaktura" tabindex="-1"><a class="header-anchor" href="#sammelfaktura"><span>Sammelfaktura</span></a></h4>
<p>Dient der Erfassung von Aufträgen, wenn die Kunden innerhalb bestimmter Zeit (meistens 1 Monat) mehrere Aufträge erteilen und auch geliefert erhalten, aber nur eine Sammelrechnung über sämtliche Aufträge erhalten wollen. Wird meist verwendet im Zusammenhang mit Wiederverkäufern. Siehe <RouteLink to="/manual/trade/sammelfakturen.html">Sammelfakturen (mehrere Rechnungen zusammenfassen</RouteLink>.</p>
<h4 id="sofortfaktura" tabindex="-1"><a class="header-anchor" href="#sofortfaktura"><span>Sofortfaktura</span></a></h4>
<p>Erlaubt den Sofortausdruck für Kunden, die ihre Waren direkt ab Lager abholen und bezahlen. Unmittelbar nach Erfassung des Auftrages wird ein WBS ausgegeben. Wird im Zusammenhang mit <RouteLink to="/manual/trade/kassenverkauf.html">Kassenverkauf</RouteLink> verwendet.</p>
<h4 id="kommissionsauftrage" tabindex="-1"><a class="header-anchor" href="#kommissionsauftrage"><span>Kommissionsaufträge</span></a></h4>
<p>Diese beruhen auf speziellen Vereinbarungen mit Wiederverkäufern, wobei nicht die gelieferten Artikel, sondern nur die effektiv verkauften Artikel durch den Wiederverkäufer bezahlt werden müssen.</p>
<p>Das System erlaubt die Erfassung einer Auftragsart mit Steuercode &quot;Wiederverkäufer&quot;. Es reagiert nach der Erfassung eines entsprechenden Auftrags wie folgt:</p>
<ol>
<li>
<p>Bei der Fakturierung wird lediglich ein Lieferschein ausgedruckt.</p>
</li>
<li>
<p>Allfällige Retouren zum Auftrag können erfasst werden.</p>
</li>
<li>
<p>Das Auslösen der eigentlichen Rechnung Muss manuell erfolgen (siehe <RouteLink to="/manual/trade/auftragsverwaltung.html">Auftragsverwaltung</RouteLink>.</p>
</li>
<li>
<p>Bei der nächsten Fakturierung wird eine Rechnung (WBS mit ESR) gedruckt.</p>
</li>
</ol>
<p>Aufgrund der Notwendigkeit, manuell einzugreifen, empfehlen wir, keine solchen Auftragsarten einzurichten. Dieselben Prozesse können über die Einrichtung und Verwaltung von externen Lagern besser gesteuert werden.</p>
<p>Siehe <RouteLink to="/manual/trade/komissionsauftraege.html">Kommissionsaufträge</RouteLink>.</p>
<p>Pfad: <code v-pre>Verkauf → Tabellen → Auftragsarten</code></p>
<h2 id="datenfelder-oberes-frame" tabindex="-1"><a class="header-anchor" href="#datenfelder-oberes-frame"><span>Datenfelder (oberes Frame)</span></a></h2>
<dl>
<dt>Auftragsart</dt>
<dd>Bezeichnung der Auftragsart</dd>
<dt>Beschreibung (ohne Label)</dt>
<dd>Beschreibung der Auftragsart</dd>
<dt>Steuercode</dt>
<dd>Für die Steuerung des Druckes von ESR und WBS in der Auftragsabwicklung. Die folgenden Steuercodes sind definiert:
<table>
<thead>
<tr>
<th>Steuercode</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>normal</td>
<td>Bei der Fakturierung wird ein WBS mit eingedrucktem Betrag erstellt.</td>
</tr>
<tr>
<td>Druckauftrag</td>
<td>Druckaufträge, d.h. Auslieferung ab externem Lager. Bei der Fakturierung werden 2 verschiedene Lieferscheine erstellt, abhängig vom Lagerort, sowie ein WBS für den Kunden.</td>
</tr>
<tr>
<td>Wiederverkäufer</td>
<td>Abwicklung von Kommissionsaufträgen mit Wiederverkäufern. Bei der Fakturierung wird ein WBS gedruckt, welcher „XXXX“ im ESR-Betragsfeld aufweist, effektiv also lediglich ein Lieferschein ist, mit dem der Kunde nicht bezahlen kann. Erst bei der manuellen Auslösung derZweitfaktura (Pfad: <code v-pre>Auftragsverwaltung → Aufträge → ./. → Freigabe Zweit-Faktur</code>) wird unter Berücksichtigung allfälliger Retouren eine Rechnung gedruckt (sog. Kommissionierungsaufträge).</td>
</tr>
</tbody>
</table>
</dd>
</dl>
<div class="hint-container warning">
<p class="hint-container-title">Achtung</p>
<p>Dieses Vorgehen ist veraltet und insofern gefährlich, als ein manueller Eingriff für jeden einzelnen Auftrag notwendig ist. Arenae empfiehlt eine Lösung über Sammelaufträge (siehe unten)
::: |
| gratis | Versand von Gratismaterial. Bei der Fakturierung validiert das System den Warenwert des Auftrags: bei Warenwert im Auftrag = 0 erstellt es eine Rechnung mit Spenden-ESR und offenem Betrag; bei Warenwert im Auftrag &gt; 0 erhält der Kunde eine normale Rechnung mit Waren-ESR. |</p>
<dl>
<dt>Umsatztyp</dt>
<dd>Umsatztyp wird aus dem Warenverkaufsereignis angezeigt (nicht editierbar).</dd>
<dt>Mandant</dt>
<dd><a class="link" href="ft.refdata.tblmandant.html" title="Mandanten">Mandant</a> in der Buchhaltung.</dd>
<dt>Sammelfaktura</dt>
<dd>Sammelfaktura (Definition siehe unten): Wird für diese Auftragsart eine Sammelrechnung benötigt?</dd>
<dt>Kundentyp</dt>
<dd>Auswahl zwischen Endverbarucher oder Wiederverkäufer</dd>
<dt>Konto</dt>
<dd>Nur für Sofortfaktura: Angabe des gewünschten Kontos für die Zahlung. Gilt nicht für die Kontierung der Fakturierung, welche über die Tabelle Kontierungsquellen gesteuert wird.</dd>
<dt>Sammelauftrag</dt>
<dd>Sammelauftrag (Definition siehe unten) Handelt es sich bei dieser Auftragsart um einen Sammelauftrag?</dd>
<dt>Personenmerkmal</dt>
<dd>Nur wenn der Auftraggeber dieses Merkmal hat, kann der Auftrag überhaupt erfasst werden.</dd>
<dt>Kostenstelle</dt>
<dd>Nur für Sofortfaktura: Angabe der gewünschten Kostenstelle für die Zahlung. Gilt nicht für die Kontierung der Fakturierung, welche über die Tabelle Kontierungsquellen gesteuert wird.</dd>
<dt>Fakturadatum verschieben um</dt>
<dd>Das Fakturierungsdatum verschieben um Anzahl Tage in die Zukunft, z.B. wenn die Ware erst zu einem späteren Zeitpunkt geliefert werden sollen.</dd>
<dt>Verkaufsereignis</dt>
<dd>Ereignis auf das der Umsatz des Auftrags verbucht werden soll.</dd>
<dt>Kostenträger</dt>
<dd>Nur für Sofortfaktura: Angabe des gewünschten Kostenträgers für die Zahlung. Gilt nicht für die Kontierung der Fakturierung, welche über die Tabelle Kontierungsquellen gesteuert wird.</dd>
<dt>Fakturadatum &gt;=</dt>
<dd>Nicht mehr in Verwendung, wird demnächst entfernt.</dd>
<dt>ESR-Nr./ESR-Code</dt>
<dd>ESR-Teilnehmernummer / Code für ESR-Teilnehmernummer</dd>
<dt>Währung</dt>
<dd>Angabe der Währung, in der die Aufträge abgewickelt werden.</dd>
<dt>Zahlungsfrist</dt>
<dd>Anzahl Tage ab Fakturierungsdatum des Auftrags, wann die Faktura im Mahnlauf berücksichtigt wird. Dient der für einzelne Auftragsarten abweichenden Steuerung des Mahnlaufs.</dd>
<dt>Debitorenkonto</dt>
<dd>Eingabe eines Debitorenkonto</dd>
<dt>Porto-Artikel</dt>
<dd>Die Artikelnummer des Portoartikels. Siehe auch <a class="xref" href="ft.refdata.tblporto.html" title="Versandkosten"><span class="refentrytitle">Versandkosten</span></a>.</dd>
<dt>Lager</dt>
<dd>Das Lager, aus dem die Waren geliefert werden sollen (und damit entsprechend bei der Fakturierung aus dem Lager abgebucht werden).</dd>
<dt>Bereitstellungsliste</dt>
<dd>Wenn ja, dann kann die Fakturierung eine Bereitstellungsliste drucken. Werden verschiedene Auftragsarten gemeinsam aufbereitet, und eine Auftragsart diesen Parameter auf <span class="guilabel">ja</span>, kann die Funktionalität genutzt werden. Die übrigen Auftragsarten werden als Portionen verstanden.</dd>
<dt>Porto vorschlagen</dt>
<dd>Soll das System bei der Auftragserfassung das Porto im Auftrag vorschlagen? Der Vorschlag wird abhängig von der gewählten Verarbeitungsart und dem Porto-Artikel aus der <a class="link" href="ft.refdata.tblporto.html" title="Versandkosten">Portotabelle</a> geholt.</dd>
<dt>Lagerreservation</dt>
<dd>Wie soll das System eine Reservierung eines Artikels bei der Auftragserfassung vornehmen? Abhängig vom Lagerbestand des Artikels im gewählten Lagerort:<br><span class="guilabel">normal</span> heisst: Lagerbestand &gt; 0: Artikel wird reserviert; Lagerbestand = 0: Artikel wird vorreserviert.<br><span class="guilabel">vorreserviert</span> heisst: In beiden Fällen setzt das System lediglich vorreserviert.</dd>
<dt>Portionsgrösse</dt>
<dd>Anzahl der pro Portion zu druckenden WBS. In einem zweiten Feld (letzte Portion + %) kann über einen Prozentwert angegeben werden, wie viel grösser die letzte Portion sein darf.</dd>
<dt>Spenden-Artikel</dt>
<dd>Standard Spende-Artikel</dd>
<dt>ext. Paketverarbeitung</dt>
<dd>Wird nur benötigt, wenn die Auslieferung mit einem externen Paketverarbeitungssystem gesteuert wird.</dd>
<dt>letzte Portion + %</dt>
<dd>Anzahl der pro Portion zu druckenden WBS. In diesem Feld wird in Prozenten angegeben, wie viel grösser die letzte Portion sein darf.</dd>
<dt>Formularcode</dt>
<dd>Formularcode, welche als WBS verwendet werden soll. Die möglichen Formulare sind kundenspezifisch und hard-coded.</dd>
<dt>Sofort-Faktura</dt>
<dd>Soll bei dieser Auftragsart direkt ein WBS auf den Drucker ausgegeben werden?</dd>
<dt>Dauerauftrag</dt>
<dd>Wenn ja, dann sind alle Aufträge von dieser Auftragsart Daueraufträge.</dd>
<dt>Sortierung</dt>
<dd>Sortierung, wie einzelne Artikel auf dem WBS aufgeführt werden sollen: A = nach Artikelnummer; P = nach Auftragspositionen (so wie im Auftrag eingegeben)</dd>
<dt>Sofortfaktura-Drucker</dt>
<dd>Drucker, auf den die WBS ausgegeben werden sollen. Da für WBS meist spezielle Formulare verwendet werden, kann hier ein spezifischer Drucker angegeben werden</dd>
<dt>Anzahl Lieferungen jährlich</dt>
<dd>Nur für Daueraufträge. Definiert die Anzahl jährlicher Lieferungen.</dd>
<dt>Nummern-Abstand</dt>
<dd>Steuerung der automatischen Numerierung der Auftragspositionen (bei der Erfassung). 1 bedeutet fortlaufende Numerierung der Auftragspositionen bei der Erfassung: 1, 2, 3, 4 ...; 2 bedeutet nur gerade Nummern: 2, 4, 6, 8 ...</dd>
<dt>Kommissionsauftrag</dt>
<dd>Bei Kommissionsauftrag kann zwischen Fakturierung oder lediglich Lieferung ausgewählt werden.</dd>
<dt>Lieferung mit Rechnung</dt>
<dd>Bei Dauerauftrag kann die Rechnung mit der ersten Lieferung oder mit letzter Lieferung erfolgen.</dd>
<dt>Anzahl unbezahlter Lieferungen</dt>
<dd>Nur für Daueraufträge. Definiert nach wie vielen unbezahlten Lieferungen die Lieferung eingestellt wird.</dd>
<dt>Dokumentensatz</dt>
<dd>Auswahl eines Dokumentensatzes für den Druck der Dokumente.</dd>
<dt>Medium editierbar</dt>
<dd>Beim erfassen eines Auftrags kann über diesen Switch eingestellt werden, ob das Medium editierbar ist.</dd>
<dt>für Mahnungen</dt>
<dd>Auswahl eines Dokumentensatzes für den Druck der Mahnungen.</dd>
<dt>Automatische Zuschussbuchung</dt>
<dd>Wird benötigt um bei Druckaufträgen eine automatische Zuschussbuchung auszulösen, da beim Einrichten in der Druckerei ein paar zusätzliche Examplare benötigt werden.</dd>
<dt>Absenderadresse</dt>
<dd>Hier kann ausgewählt werden mit welcher Absenderadresse der Auftrag gedruckt werden soll.</dd>
<dt>Rabattsatz manuell anpassen</dt>
<dd>Durch diesen Schalter wird definiert, ob der Rabattsatz bei der Auftragserfassung manuell angepasst werden kann.</dd>
<dt>Buchung transistorische Passiven</dt>
<dd>Ja = Artikelumsätze können auf zwei Daten unterteilt werden.</dd>
<dt>MWST-Text</dt>
<dd>In diesem Feld kann ein beliebiger Freitext für den Mehrwertsteuersatz ausgegeben werden.</dd>
</dl>
<h2 id="datenfelder-unteres-frame" tabindex="-1"><a class="header-anchor" href="#datenfelder-unteres-frame"><span>Datenfelder (unteres Frame)</span></a></h2>
<dl>
<dt>Auftragsart</dt>
<dd>Bezeichnung der Auftragsart</dd>
<dt>Mandant</dt>
<dd><a class="link" href="ft.refdata.tblmandant.html" title="Mandanten">Mandant</a> in der Buchhaltung.</dd>
<dt>Steuercode</dt>
<dd>Für die Steuerung des Druckes von ESR und WBS in der Auftragsabwicklung. Die folgenden Steuercodes sind definiert:| Steuercode | Bedeutung |
| --- | --- |
| normal | Bei der Fakturierung wird ein WBS mit eingedrucktem Betrag erstellt. |
| Druckauftrag | Druckaufträge, d.h. Auslieferung ab externem Lager. Bei der Fakturierung werden 2 verschiedene Lieferscheine erstellt, abhängig vom Lagerort, sowie ein WBS für den Kunden. |
| Wiederverkäufer | Abwicklung von Kommissionsaufträgen mit Wiederverkäufern. Bei der Fakturierung wird ein WBS gedruckt, welcher „XXXX“ im ESR-Betragsfeld aufweist, effektiv also lediglich ein Lieferschein ist, mit dem der Kunde nicht bezahlen kann. Erst bei der manuellen Auslösung derZweitfaktura (Pfad: Auftragsverwaltung → Aufträge → ./. → Freigabe Zweit-Faktur) wird unter Berücksichtigung allfälliger Retouren eine Rechnung gedruckt (sog. Kommissionierungsaufträge).</dd>
</dl>
<div class="hint-container warning">
<p class="hint-container-title">Achtung</p>
<p>Dieses Vorgehen ist veraltet und insofern gefährlich, als ein manueller Eingriff für jeden einzelnen Auftrag notwendig ist. Arenae empfiehlt eine Lösung über Sammelaufträge (siehe unten)
::: |
| gratis | Versand von Gratismaterial. Bei der Fakturierung validiert das System den Warenwert des Auftrags: bei Warenwert im Auftrag = 0 erstellt es eine Rechnung mit Spenden-ESR und offenem Betrag; bei Warenwert im Auftrag &gt; 0 erhält der Kunde eine normale Rechnung mit Waren-ESR. |</p>
<dl>
<dt>Beschreibung</dt>
<dd>Beschreibung der Auftragsart</dd>
<dt>ESR-Code</dt>
<dd>Code für ESR-Teilnehmernummer</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<ul>
<li><RouteLink to="/manual/trade/auftragsverwaltung.html">Auftragsverwaltung</RouteLink></li>
<li><RouteLink to="/manual/trade/dauerauftraege_alt.html">Daueraufträge</RouteLink></li>
<li><RouteLink to="/manual/trade/sammelfakturen.html">Sammelfakturen (mehrere Rechnungen zusammenfassen</RouteLink></li>
</ul>
</div>
</div>
</div></template>


